import {
  SetStateAction,
  Dispatch,
  createContext,
  useState,
  useEffect,
  useContext,
} from "react";
import { sidebarData, otherRoutes } from "./sidebarData";
import { useAppSelector } from "core/store/reduxStore";
import { filterSidebarByProviders } from "core/utils/providerFilter";

export type SideBarContextType = {
  sidebarActiveState: string;
  setSidebarActiveState: (id: string) => void;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (status: boolean) => void;
  isMobile: boolean;
  setIsMobile: (status: boolean) => void;
  activeItem: string;
  setActiveItem: (id: string) => void;
  expandedNodes: { [key: string]: boolean };
  setExpandedNodes: Dispatch<SetStateAction<{ [key: string]: boolean }>>;
  routeData: any;
  setRouteData: any;
  modelData: any;
  setModelData: any;
  setSidesideBarItemPositionTop: any;
  sidesideBarItemPositionTop: number;
  sidesideBarItemPositionRight: number;
  setSidesideBarItemPositionRight: any;
  showHideTooltip: boolean;
  setShowHideTooltip: any;
  setSidebarParentNode: any;
  sidebarParentNode: any;
};

const initialState: SideBarContextType = {
  sidebarActiveState: "",
  setSidebarActiveState: () => {},
  isDrawerOpen: false,
  activeItem: "", // Add this missing property
  setIsDrawerOpen: () => {},
  setActiveItem: () => {},
  expandedNodes: {},
  setExpandedNodes: () => {},
  isMobile: false,
  setIsMobile: () => {},
  routeData: [],
  setRouteData: () => {},
  modelData: [],
  setModelData: () => {},
  setSidesideBarItemPositionTop: () => {},
  setSidesideBarItemPositionRight: () => {},
  sidesideBarItemPositionRight: 0,
  sidesideBarItemPositionTop: 0,
  showHideTooltip: false,
  setShowHideTooltip: () => {},
  setSidebarParentNode: () => {},
  sidebarParentNode: {},
};

export const SidebarContext = createContext<SideBarContextType>(initialState);
function deepCopy(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepCopy(item));
  }

  const copy = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      copy[key] = deepCopy(obj[key]);
    }
  }
  return copy;
}

const getData = (routeData) => {
  let organizeData: any = deepCopy(routeData);
  organizeData.forEach((value, key) => {
    if (value?.children) {
      if (value.children.length === 0) {
        console.log(`Removing empty children from ${value}`);
        delete value.children;
      } else {
        value.children.forEach((value1, key1) => {
          for (let key in value1) {
            if (Array.isArray(value1[key]) && key === "children") {
              delete value1[key];
            }
          }
        });
      }
    }
  });
  return organizeData;
};

export const SidebarProvider = ({ children }) => {
  const [sidebarActiveState, setSidebarActiveState] = useState<string>("");
  const [activeItem, setActiveItem] = useState<string>("");
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [expandedNodes, setExpandedNodes] = useState<{}>({});
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [routeData, setRouteData] = useState<any>(getData(sidebarData));
  const [modelData, setModelData] = useState<any>([]);
  const [sidesideBarItemPositionTop, setSidesideBarItemPositionTop] =
    useState<number>(0);
  const [sidesideBarItemPositionRight, setSidesideBarItemPositionRight] =
    useState<number>(0);
  const [showHideTooltip, setShowHideTooltip] = useState(false);
  const [sidebarParentNode, setSidebarParentNode] = useState({});

  // Get providers from Redux store
  const providers = useAppSelector(
    (state) => state.chatConversations.providers
  );

  // Filter sidebar data when providers change
  useEffect(() => {
    const filteredRoutes = filterSidebarByProviders(
      sidebarData,
      otherRoutes,
      providers ? providers : [] 
    );

    const data = getData(filteredRoutes);
    setRouteData(data);
    setModelData(filteredRoutes);
    console.log("filteredRoutes", filteredRoutes);
    console.log("modelData", modelData);
  }, [providers]);

  return (
    <SidebarContext.Provider
      value={{
        setActiveItem,
        activeItem,
        sidebarActiveState,
        setSidebarActiveState,
        isDrawerOpen,
        setIsDrawerOpen,
        expandedNodes,
        setExpandedNodes,
        isMobile,
        setIsMobile,
        routeData,
        setRouteData,
        modelData,
        setModelData,
        sidesideBarItemPositionTop,
        setSidesideBarItemPositionTop,
        sidesideBarItemPositionRight,
        setSidesideBarItemPositionRight,
        showHideTooltip,
        setShowHideTooltip,
        setSidebarParentNode,
        sidebarParentNode,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
